import React, { useCallback, useContext, useEffect, useState } from 'react';

import OptimizeContext from '@totem/components/portfolio/buildings/details/optimize/OptimizeContext';
import { Program } from '@totem/components/portfolio/buildings/details/optimize/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { BUILDINGS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  buildingId: string;
  children: React.ReactNode;
};

const OptimizeContainer = ({ buildingId, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [programs, setPrograms] = useState<Program[]>([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    if (!refresh) {
      return;
    }

    setRefresh(false);

    setLoading(true);

    fetch(`${BUILDINGS_ENDPOINT}/${buildingId}/optimize/programs`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: Program[]) => {
        setPrograms(Array.isArray(result) ? result : []);
      })
      .finally(() => setLoading(false));
  }, [refresh, buildingId, getApiToken]);

  const requestRefresh = useCallback(() => setRefresh(true), []);

  return (
    <OptimizeContext.Provider
      value={{ buildingId, programs, loading, requestRefresh }}
    >
      {children}
    </OptimizeContext.Provider>
  );
};

export default OptimizeContainer;
